import { Model } from "../../shared/models/model";

export class Physician extends Model {
  constructor(attributes) {
    super({ ...attributes, id: attributes?.id?.toString() });
  }
  get defaults() {
    return {
      id: undefined,
      name: undefined,
      visitTypes: undefined,
    };
  }
}
